import React from 'react';
import { CaretRightOutlined, DropdownMenu } from '@landr/maestro';
import { searchV3FilterType } from 'components/Filters/Filters';
import { Trans } from '@lingui/macro';
import { FiltersParams, TagCategoryParams } from 'types/params';
import useSearchTools from '../hooks/useSearchTools';

const SearchToolsDropdownTrigger = ({
    toolsType,
}: {
    toolsType: searchV3FilterType | FiltersParams | TagCategoryParams;
}) => {
    const { ActiveTypeLabel, isTypeFilter, isBpmFilter, isKeyFilter } =
        useSearchTools({ toolsType });

    let label = null;

    if (isTypeFilter) {
        label = ActiveTypeLabel;
    } else if (isBpmFilter) {
        label = <Trans>BPM</Trans>;
    } else if (isKeyFilter) {
        label = <Trans>Key</Trans>;
    } else {
        switch (toolsType) {
            case FiltersParams.instruments:
                label = <Trans>Instruments</Trans>;
                break;
            case FiltersParams.genres:
                label = <Trans>Genres</Trans>;
                break;
            case FiltersParams.sfxs:
                label = <Trans>SFX</Trans>;
                break;
            case TagCategoryParams.artist:
                label = <Trans>Artist</Trans>;
                break;
            case TagCategoryParams.timbre:
                label = <Trans>Timbre</Trans>;
                break;
            case TagCategoryParams.mood:
                label = <Trans>Mood</Trans>;
                break;
            case TagCategoryParams.city:
                label = <Trans>City</Trans>;
                break;
            case TagCategoryParams.music_gear:
                label = <Trans>Music Gear</Trans>;
                break;
            case TagCategoryParams.other:
                label = <Trans>Other</Trans>;
                break;
            default:
                label = null;
        }
    }

    return (
        <DropdownMenu.Trigger>
            <DropdownMenu.Item as="button">
                {label}
                <DropdownMenu.SecondaryAction>
                    <CaretRightOutlined />
                </DropdownMenu.SecondaryAction>
            </DropdownMenu.Item>
        </DropdownMenu.Trigger>
    );
};

export default SearchToolsDropdownTrigger;
